export default "__VITE_ASSET__B3dEBy4H__"